import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/app/process-management/components/ProcessManagementInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/deploy/src/components/common/Sidebar.tsx");
